import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import * as angular from "angular";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import { IGeofence, GeofenceCategory } from "@interfaces/IGeofences";
import { GeofenceService } from "@services/geofence.service";
import { IGeofenceFilter } from "@interfaces/filters/IGeofenceFilter";
import "./geofenceResourceFilter.scss";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { TranslationService } from "@services/translation.service";

interface IComponentBindings {
    selectedGeofence: IGeofence;
    geofenceId: number;
}

class ComponentController implements angular.IComponentController, IComponentBindings, IFilterBarFilter<IGeofenceFilter>{
    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "Geofence";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    geofences: IGeofence[];
    selectedGeofence: IGeofence;
    geofenceId: number;

    previousFilter: IGeofenceFilter;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<IGeofence>[];

    hideZones: boolean;

    onChange: (args: { filter: IGeofenceFilter }) => void;

    static $inject = ["$rootScope", "$element", "$timeout", "geofenceService", "translationService"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        public readonly $element: HTMLElement,
        private readonly $timeout: angular.ITimeoutService,
        private readonly geofenceService: GeofenceService,
        private readonly translationService: TranslationService    ) {
    }

    $onInit() {
        this.parent.registerFilter(this);

        this.createTableHeaders();       
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();

        if (onChangesObj['geofenceId']) {
            this.selectedGeofence = null;
            this.getGeofences();
        }    
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.getGeofences();
        }
    }    

    clearFilter() {
        this.selectedGeofence = null;
        this.geofenceId = null;

        this.updateFilterLabel();
    }

    selectedGeofenceChanged(geofence: IGeofence) {
        this.geofenceId = null;

        if (this.selectedGeofence == geofence) {
            this.selectedGeofence = null;
        } else {
            this.selectedGeofence = geofence;
        }

        this.updateFilterLabel();

        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    createFilterObject(): IGeofenceFilter {
        return {
            geofence: this.selectedGeofence
        };
    }    

    // ------------------

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.translationService.t('Common.Geofences'), sortable: true },
        ];
    }

    private getGeofences() {
        this.geofenceService.getGeofences().then(geofences => {
            
            if (this.hideZones) {
                this.geofences = geofences.filter(geofence => geofence.Category === GeofenceCategory.Standard);
            } else {
                this.geofences = geofences;
            }


        }).finally(() => {
            this.createTableRows();
            this.updateFilterLabel();
        });
    }

    private updateFilterLabel() {
        this.filterLabel = this.translationService.t('filters.geofenceResourceFilter.allGeofences');
        this.filterIcon = "filter_tilt_shift";

        if (this.geofences && this.geofenceId) {
            this.selectedGeofence = this.geofences.find(geofence => geofence.Id === this.geofenceId);
        }

        if (this.selectedGeofence) {
            this.filterLabel = this.selectedGeofence.Description;
        }

        this.isDirty = !!this.selectedGeofence;
    }

    private createTableRows() {
        this.tableRows = [];

        this.geofences.forEach(geofence => {
            this.tableRows.push({
                data: geofence,
                cells: this.createTableCells(geofence)
            });
        });
    }

    private createTableCells(geofence: IGeofence): IVeriTableRowCell[] {
        const cells: IVeriTableRowCell[] = [
            {
                contents: geofence.Description, data: geofence, sortData: geofence.Description
            },
        ];

        return cells;
    }
}

export class GeofenceResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            selectedGeofence: "<geofence",
            geofenceId: "<?",
            hideZones: "<?",
            onChange: "&"
        };

        this.require = {
            parent: "^newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./geofenceResourceFilter.html");
    }
}
